// In src/pages/TermsPage.js

import React from 'react';
import { useProfile } from '../context/ProfileContext';
import TermsOfService202611 from "../components/miscellaneous/TermsOfService202611";

const TermsPage = () => {
    const { isDarkMode } = useProfile();

    return (
        /* ✅ Dynamic background and base text color toggle */
        <div className={`min-h-screen transition-colors duration-500 ${isDarkMode ? 'bg-brand-black text-zinc-100' : 'bg-white text-gray-900'}`}>
            <div className="max-w-4xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
                <div className="text-center">
                    {/* ✅ Heading colors */}
                    <h1 className={`text-3xl font-extrabold sm:text-4xl uppercase tracking-tighter italic ${isDarkMode ? 'text-white' : 'text-gray-900'}`}>
                        Terms and Conditions
                    </h1>
                    <p className={`mt-4 text-lg font-bold tracking-widest uppercase text-[10px] ${isDarkMode ? 'text-brand-pink' : 'text-gray-500'}`}>
                        Last updated: November 5, 2026
                    </p>
                </div>

                {/* ✅ Added explicit text color to the prose container so text inherits gray-900 in light mode */}
                <div className={`mt-12 prose prose-lg mx-auto transition-colors duration-500 ${
                    isDarkMode ? 'prose-invert text-zinc-100' : 'text-gray-900'
                }`}>
                    <TermsOfService202611 />
                </div>
            </div>
        </div>
    );
};

export default TermsPage;